'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Row, Container, Col } from 'reactstrap';
import dayjs from '../utils/dayjs';
import Link from 'next/link';
import { MdCalendarToday, MdAccessTime, MdLocationPin } from 'react-icons/md';
import IndexJobSearchForm from './IndexJobSearchForm';
import EventTeaser from './EventTeaser';
import RegistrationForm from './RegistrationForm';
import { Dictionaries, Locale } from '../i18n/i18n-config';
import { getI18nUtils } from '../i18n/i18n-utils';

type Props = {
  event: any;
  latestEvents: any;
  locale: Locale;
  dictionary: Partial<Dictionaries>;
};

function Event({ event, latestEvents, locale, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <Container className="mb-4">
      <Link className="return d-block mb-4" href={`/${locale}/events/`}>
        {formatMessage({ id: 'job-back-to-result' })}
      </Link>
      <Row className="mb-4">
        <Col lg={8}>
          <h1 className="mb-4">{event.title}</h1>
          {(!!event.location || event.dates?.length > 0) && (
            <Row className="pt-4 pb-4 mt-4 mb-4 border-top border-bottom">
              <Col xs="12">
                {event.location && event.location.city !== null && (
                  <address className="mb-0">
                    <MdLocationPin color="#5ED1C6" size="22" className="me-2" />

                    <span style={{ verticalAlign: 'middle' }}>
                      {`${event.location.street} ${event.location.houseNumber}, ${event.location.postalCode} ${event.location.city}`}
                    </span>
                  </address>
                )}
              </Col>
              {event.dates.map((date, index) => (
                <Col xs={12} key={`date-${index}`} className="mt-4">
                  <time dateTime={dayjs(`${date.dateFrom} ${date.startTime}`, 'DD-MM-YYYY HH:mm').format()}>
                    <div className="me-3">
                      <MdCalendarToday size="22" className="me-2" color="#5ED1C6" />

                      <span style={{ verticalAlign: 'middle' }}>{date.dateFrom}</span>
                    </div>
                    {date.startTime && (
                      <div>
                        <MdAccessTime size="22" className="me-2" color="#5ED1C6" />

                        <span style={{ verticalAlign: 'middle' }}>
                          {date.startTime}
                          {date.endTime ? ` - ${date.endTime}` : ''}
                        </span>
                      </div>
                    )}
                  </time>
                </Col>
              ))}
            </Row>
          )}
          <div className="eventDescription" dangerouslySetInnerHTML={{ __html: event.description }} />
        </Col>
        <Col lg={4}>
          <aside>
            <IndexJobSearchForm dictionary={dictionary} className="d-none d-lg-block" id="side" withHeader />
            {event.location && event.location.city !== null && (
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  frameBorder="0"
                  src={`https://www.google.com/maps/embed/v1/place?q=${event.location.street || ''}+${
                    event.location.houseNumber || ''
                  }+${event.location.postalCode || ''}+${event.location.city || ''}&key=AIzaSyBupFH0E8sisWkj87o6MEYxFRueNVm9RuY`}
                  allowFullScreen
                  title="google map"
                />
              </div>
            )}
          </aside>
        </Col>
      </Row>
      {event.registrationForm && (
        <Row className="mb-4">
          <Col lg={8}>
            <RegistrationForm dictionary={dictionary} id={event.id} source="event" content={{ cvUpload: event.cvUpload }} />
          </Col>
        </Row>
      )}
      <Row className="mb-4">
        {latestEvents
          .filter((evt) => evt.id !== event.id)
          .map((evt) => (
            <Col lg={6} className="mb-4" key={evt.id}>
              <EventTeaser event={evt} dictionary={dictionary} />
            </Col>
          ))}
      </Row>
    </Container>
  );
}

export default Event;
